export default function AnnotationsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="30"
      viewBox="0 0 27 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.215 0H19.7865C24.42 0 27 2.67 27 7.245V22.74C27 27.39 24.42 30 19.7865 30H7.215C2.655 30 0 27.39 0 22.74V7.245C0 2.67 2.655 0 7.215 0ZM7.30477 7.015V7H11.7883C12.4348 7 12.9598 7.525 12.9598 8.1685C12.9598 8.83 12.4348 9.355 11.7883 9.355H7.30477C6.65827 9.355 6.13477 8.83 6.13477 8.185C6.13477 7.54 6.65827 7.015 7.30477 7.015ZM7.30477 16.1384H19.0648C19.7098 16.1384 20.2348 15.6134 20.2348 14.9684C20.2348 14.3234 19.7098 13.7969 19.0648 13.7969H7.30477C6.65827 13.7969 6.13477 14.3234 6.13477 14.9684C6.13477 15.6134 6.65827 16.1384 7.30477 16.1384ZM7.305 22.9899H19.065C19.6635 22.9299 20.115 22.4184 20.115 21.8199C20.115 21.2049 19.6635 20.6949 19.065 20.6349H7.305C6.855 20.5899 6.42 20.7999 6.18 21.1899C5.94 21.5649 5.94 22.0599 6.18 22.4499C6.42 22.8249 6.855 23.0499 7.305 22.9899Z"
        fill="currentColor"
      />
    </svg>
  );
}
